// --------------------------------------------------------
// DETAILS ATTENDANCE RECORD - AttendanceRecord
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
"use client";

import React, { useCallback, useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { GenericSolidButton, OutlinedUpdateButton } from "../../../../../../components/UI/buttons/Button.styled";
import ContainerWithSidebar from "../../../../../../components/UI/containerWithSidebar/ContainerWithSidebar";
import {
  H1,
  H2,
  H3,
} from "../../../../../../components/UI/generalLayout/Layout.styled";
import { Spacer } from "../../../../../../components/UI/spacer/spacer";
import Colors from "../../../../../../constants/Colors";
import useResponsiveInfo from "../../../../../../hooks/useResponsiveInfo";
import { CancelButton } from "../../../careLines/AttachCareLine";
import {
  Box,
  BoxAtendimentoFinalizado,
  BoxAttendance,
  CheckBox,
  Contents,
  GeneralContainer,
  OptionSelect,
  Subtitle,
  TextLink,
} from "./DetailsAttendanceRecord.styled";
import DetailsAttendanceRecordAccordion from "./DetailsAttendanceRecordAccordion";
import AtestadoDeclaracaoField from "./fields/AtestadoDeclaracaoField";
import EvolucaoField from "./fields/EvolucaoField";
import ReceituarioField from "./fields/ReceituarioField";
import ExamesField from "./fields/ExamesField";
import TriagemField from "./fields/TriagemField";
import EncaminhamentoField from "./fields/EncaminhamentoField";
import LiberacaoField from "./fields/LiberacaoField";
import AltaProfissionalField from "./fields/AltaProfissionalField";
import GenericModal from "../../../../../../components/genericModal/GenericModal";
import NavegacaoField from "./fields/NavegacaoField";
import { NavegacaoService } from "../../../../../../core/http/service/NavegacaoService";
import { handleBackendErrors } from "../../../../../../helpers/HelperFunctions";
import Exam from "../../../../../../models/core/careLine/Exam";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../../../..";
import * as careLineActions from "../../../../../../store/actions/careLine";
import * as appointmentActions from "../../../../../../store/actions/appointment";
import CareLine from "../../../../../../models/core/careLine/CareLine";
import moment from "moment";
import { Paths } from "../../../../../../enums/Paths";
import ErrorArea from "../../../../../../components/error/ErrorArea";
import { AppointmentService } from "../../../../../../core/http/service/AppointmentService";
import { PersonService } from "../../../../../../core/http/service/PersonService";
import useFetchCareLinesOccupHealthHelper from "../../../../../../hooks/useFetchCareLinesOccupHealthHelper";
import { CircularProgress } from "@mui/material";
import ModalImpreviveis from "../modalImpremiveis/ModalImpremiveis";
import { CareLineService } from "../../../../../../core/http/service/CareLineService";
import BaseResponse from "../../../../../../models/core/BaseResponse";
import ListaDeProblemasField from "./fields/ListaDeProblemasField";
import { isNull } from "lodash";
import "moment/locale/pt-br";
import { FETCH_ATENDIMENTO_STATUS_SALVAR } from "../../../../../../store/actions/appointment";
import { BiLinkExternal } from "react-icons/bi";
import ProntuarioDrawer from "./ProntuarioDrawer";
import JustificationFinalizationModal from "../../../../../../components/justificationFinalizationModal/JustificationFinalizationModal";
import ClinicFrameConfiguracaoService from "../../../../../../core/http/service/ClinicFrameConfiguracaoService";

// --------------------------------------------------------
// DETAILS ATTENDANCE RECORD INTERFACE
// --------------------------------------------------------
/**
 * A component that renders a Screen.
 *
 * @param props Properties
 * @param props.route The route
 * @param props.navigation The navigator
 * @returns The component JSX.
 */

export interface IDetailsAttendanceRecord { }

function DetailsAttendanceRecord({ }: IDetailsAttendanceRecord): JSX.Element {
  // --------------------------------------------------------
  // DETAILS ATTENDANCE RECORD PRIVATE DECLARATIONS
  // --------------------------------------------------------

  const navigate = useNavigate();
  const { state } = useLocation();
  const { isMobile } = useResponsiveInfo();
  const { pessoa, atendimentoId, finalizado, agendamento } = (state as any) ?? {};
  //console.log(
  //  "🚀 ~ file: DetailsAttendanceRecord.tsx:85 ~ DetailsAttendanceRecord ~ agendamento:",
  //  agendamento
  //);

  const [profile, setProfile] = useState(``);
  const [useClinicFrame, setUseClinicFrame] = useState(false);
  const [clinicFrameConfig, setClinicFrameConfig] = useState<any>(null);
  const [medicoFamiliaNome, setMedicoFamiliaNome] = useState<string | undefined>();

  const [registroAtendimento, setRegistroAtendimento] = useState<any>();
  const isViewState = finalizado;
  const [error, setError] = useState<any>();
  const [triagemObject, setTriagemObject] = useState({ sinaisVitais: "", sinaisVitaisList: [] as any[] });
  const [evolucaoObject, setEvolucaoObject] = useState({
    subjetivo: "",
    objetivo: "",
    avaliacao: "",
    plano: "",
    cidPrincipal: { descricao: "", id: "", codigo: "" },
    cidSecundario: { descricao: "", id: "", codigo: "" },
  });
  const [receituarios, setReceituarios] = useState<any[]>([
    { descricao: "" },
  ]);
  const [receituariosEspeciais, setReceituariosEspeciais] = useState<any[]>([
    { descricao: "" },
  ]);
  const { statusSalvar, appointmentId } = useSelector((state: any) => state.appointment);
  const [atestadoDeclaracao, setAtestadoDeclaracao] = useState({
    tipo: "",
    data: registroAtendimento && registroAtendimento.atestado ? moment(registroAtendimento?.atestado.dia).format("DD/MM/YYYY") : moment(agendamento?.horario).format("DD/MM/YYYY"),
    horario: registroAtendimento && registroAtendimento.atestado ? moment(registroAtendimento?.atestado.horaInicio).format("DD/MM/YYYY") : moment(agendamento?.horario).format("HH:mm"),
    notas: "",
    diasAfastados: "0",
    horarioFim: "",
  });

  const [encaminhamentos, setEncaminhamentos] = useState([
    { especialidade: "", resumo: "", examesComplementares: "", hipoteses: "" },
  ]);
  const [liberacoes, setLiberacoes] = useState([
    { tipoProfissional: "", numeroSessoes: "", orientacoes: "" },
  ]);
  const [altas, setAltas] = useState([
    { dataHora: new Date(), motivo: "" },
  ]);
  const [exibirAltaProfissional, setExibirAltaProfissional] = useState(false);
  const [navegacao, setNavegacao] = useState<any>(null);
  const [isAlreadyInNavigation, setIsAlreadyInNavigation] = useState(false);
  const [isLoadingInfo, setIsLoadingInfo] = useState(false);
  const [showModalFinalizar, setShowModalFinalizar] = useState(false);
  const [showJustificationModal, setShowJustificationModal] = useState(false);
  const [isFinalizing, setIsFinalizing] = useState(false);
  const [personCareLines, setCareLines] = useState<any[]>([]);
  const [selectedCareLines, setSelectedCareLines] = useState<any[]>([]);
  const [personOccupHealth, setOccupHealth] = useState<any[]>([]);
  const [selectedOccupHealth, setSelectedOccupHealth] = useState<any[]>([]);
  const [examesToSelect, setExamsToSelected] = useState<any[]>([]);
  const [selectedExams, setSelectedExams] = useState<any[]>([]);
  const [extraExams, setExtraExams] = useState<any[]>([]);
  const [problems, setProblems] = useState<string>("");
  const ref = useRef<HTMLButtonElement>(null);
  const [isEnabled, setIsEnabled] = useState(true);
  const { currentProfile }: any = useSelector((state: any) => state.login);
  const acessoProntuario = useSelector((state: any) => state.person.acessoProntuario)

  const [atendimentoFinalizadoInfo, setAtendimentoFinalizadoInfo] = useState({
    atendimentoId: "",
    profissional: "",
    tipoDeProfissional: "",
    data: "",
    finalizadoPor: "",
    finalizadoEm: "",
    justificativa: "",
  });

  const allExams: Exam[] = useSelector((state: any) => state.careLine.allExams);

  const careLineList: CareLine[] = useSelector(
    (state: any) => state.careLine.careLines
  );

  const userInfo: any = useSelector((state: any) => state.login.userInfo);

  const dependenteProfile: any = useSelector((state: any) => state.login.dependenteProfile);

  const service: AppointmentService = new AppointmentService();

  const { fetchPersonCareLines, fetchPersonOccupHealth } =
    useFetchCareLinesOccupHealthHelper(pessoa);

  const getCareLines = useCallback(async () => {
    const careLines: any[] = (await fetchPersonCareLines()) ?? [];

    setCareLines(careLines);
  }, []);

  const getOccupHealth = useCallback(async () => {
    const careLines: any[] = (await fetchPersonOccupHealth()) ?? [];
    setOccupHealth(careLines);
  }, []);

  const dispatch = useAppDispatch();

  const getExamData = useCallback(async () => {
    await dispatch(careLineActions.fetchDropdownData());
    await dispatch(careLineActions.fetchCareLines());
  }, []);

  const [modalAttendance, setModalAttendance] = useState(false);



  const fillObjectsForView = async (objectFromServer: any) => {

    try {

      setIsLoadingInfo(true);
      //Infos de atendimento finalizado
      setAtendimentoFinalizadoInfo({
        profissional: objectFromServer.profissional.nome,
        tipoDeProfissional: agendamento.tipoProfissional, //mexer
        data: moment(objectFromServer.horario).format("DD/MM/YYYY HH:mm"),
        atendimentoId: objectFromServer.id,
        finalizadoPor: objectFromServer.finalizadoPorNome,
        finalizadoEm: objectFromServer.dataFinalizacao ? moment(objectFromServer.dataFinalizacao).format("DD/MM/YYYY HH:mm") : "",
        justificativa: objectFromServer.justificativaFinalizacao,
      });
      setExibirAltaProfissional(objectFromServer.exibirAltaProfissional);
      //Linhas de Cuidado
      const careLinesIds = objectFromServer.linhasCuidado.map(
        (careLine: any) => careLine.linhaCuidadoId
      );

      let careLinesList = careLineList;

      if (careLinesList.length === 0) {
        const service: CareLineService = new CareLineService();
        try {
          const response: any = await service.getCareLines();
          const baseResponse: BaseResponse<any> = new BaseResponse().fromJSON(
            response.data
          );
          baseResponse.data.forEach((data: any) => {
            careLinesList.push(new CareLine().fromJSON(data));
          });
        } catch (error: any) {
          throw error;
        }
      }

      const linhasCuidado = careLinesList.filter(cl => {
        return careLinesIds.includes(cl.id);
      });

      const careLinesCheck: any[] = (await fetchPersonCareLines()) ?? [];

      linhasCuidado.map((cl: { id: any }) => {
        const exists = careLinesCheck.some(existingCL => existingCL.id === cl.id);

        if (!exists) {
          setCareLines(prevState => [...prevState, cl]);
        }
      });

      setSelectedCareLines(linhasCuidado);

      //Saúdes ocupacionais
      const occupHealthIds = objectFromServer.saudesOcupacionais.map(
        (so: any) => so.saudeOcupacionalId
      );

      const careLines: any[] = (await fetchPersonOccupHealth()) ?? [];

      const saudesOcupacionais = careLines.filter(saudeOcupacional => {
        return occupHealthIds.includes(saudeOcupacional.id);
      });

      setSelectedOccupHealth(saudesOcupacionais);

      //Problemas

      if (!isNull(objectFromServer.problemas)) {
        setProblems(objectFromServer.problemas);
      } else {
        setProblems("");
      }

      //Exames solicitados
      const examsIds = objectFromServer.examesSolicitacoes
        .filter((ex: any) => {
          return !ex.exameAdicional;
        })
        .map((ex: any) => ex.exame.id);
      const extraExams = objectFromServer.examesSolicitacoes
        .filter((ex: any) => {
          return ex.exameAdicional;
        })
        .map((ex: any) => { return { exame: ex.exame, justificativa: ex.justificativa }; });
      const exames = allExams.filter(exams => {
        return examsIds.includes(exams.id);
      });
      //const extraExams = allExams.filter(exams => {
      //  return extraExamsIds.includes(exams.id);
      //});
      setSelectedExams(exames);
      setExtraExams(extraExams);
      //Triagem
      setTriagemObject({
        sinaisVitais: objectFromServer.triagemSinaisVitais,
        sinaisVitaisList: objectFromServer.sinaisVitais || []
      });
      //Evolução
      const cidPrincipal =
        objectFromServer.cid.length > 0
          ? objectFromServer.cid[0]
          : { descricao: "", id: "", codigo: "" };
      const cidSecundario =
        objectFromServer.cid.length > 1
          ? objectFromServer.cid[1]
          : { descricao: "", id: "", codigo: "" };

      setEvolucaoObject({
        avaliacao: objectFromServer.evolucaoAvaliacao,
        objetivo: objectFromServer.evolucaoObjetivo,
        plano: objectFromServer.evolucaoPlano,
        subjetivo: objectFromServer.evolucaoSubjetivo,
        cidPrincipal: cidPrincipal,
        cidSecundario: cidSecundario,
      });
      //Receituário
      setReceituarios(objectFromServer.receituarios);
      setReceituariosEspeciais(objectFromServer.receituarioEspecial);
      //Exames solicitados

      //Atestado/declaração
      const atestadoDeclaracao =
        objectFromServer.atestado !== null
          ? { ...objectFromServer.atestado, horarioFim: null }
          : objectFromServer.declaracao !== null
            ? { ...objectFromServer.declaracao, diasAfastamento: null }
            : null;

      if (atestadoDeclaracao !== null) {
        const object = {
          tipo: objectFromServer.atestado !== null ? "atestado" : "declaracao",
          data: moment(atestadoDeclaracao.dia, "YYYY-MM-DD").format("DD/MM/YYYY"),
          diasAfastados:
            atestadoDeclaracao?.diasAfastamento !== null
              ? String(atestadoDeclaracao.diasAfastamento)
              : "",
          horario: moment(atestadoDeclaracao.horaInicio, "HH:mm").format("HH:mm"),
          horarioFim: atestadoDeclaracao.horaFim
            ? moment(atestadoDeclaracao.horaFim, "HH:mm").format("HH:mm")
            : "",
          notas: atestadoDeclaracao.notas,
        };
        setAtestadoDeclaracao(object);
      }

      //Encaminhamento
      const encaminhamentosServer = objectFromServer.encaminhamentos.map(
        (value: any) => ({
          id: value.id,
          especialidade: value.especialidade,
          resumo: value.resumoAtendimento,
          examesComplementares: value.examesComplementares,
          hipoteses: value.hipotesesMotivosReferenciar,
        })
      );
      setEncaminhamentos(
        encaminhamentosServer.length > 0
          ? encaminhamentosServer
          : [
            {
              especialidade: "",
              resumo: "",
              examesComplementares: "",
              hipoteses: "",
            },
          ]
      );
      //Liberacao
      const liberacoes = objectFromServer.liberacoesProfissionais.map(
        (value: any) => ({
          id: value.id,
          tipoProfissional: value.categoria,
          numeroSessoes: String(value.numeroSessoes),
          orientacoes: value.orientacoes || "",
        })
      );
      setLiberacoes(
        liberacoes.length > 0
          ? liberacoes
          : [{ tipoProfissional: "", numeroSessoes: "", orientacoes: "" }]
      );

      //Alta Profissional
      const altasServer = (objectFromServer.altasProfissionais || []).map(
        (value: any) => ({
          id: value.id,
          dataHora: value.dataHora,
          motivo: value.motivo,
        })
      );
      setAltas(
        altasServer.length > 0
          ? altasServer
          : [{ dataHora: new Date(), motivo: "" }]
      );

      if (objectFromServer.navegacao) {
        setNavegacao({
          ...objectFromServer.navegacao,
          isInitialized: true
        });
      } else {
        setNavegacao(null);
      }

      setIsLoadingInfo(false);
    } catch (error) {
      setIsLoadingInfo(false);
      console.log(error)
    }

  };

  const getAtendimentoDetailData = useCallback(async (id: any) => {
    if (!id) return;
    const result: any = await service.getAtendimentoDetail(id);
    const registroAtendimento: any = result.data.data;
       setRegistroAtendimento(registroAtendimento);
       fillObjectsForView(registroAtendimento);
  }, []);

  useEffect(() => {
    if (ref.current) {
      ref.current.disabled = !isEnabled;
    }
  }, [isEnabled]);

  useEffect(() => {
    if (state !== null && !!atendimentoId) {
      getAtendimentoDetailData(atendimentoId);
    }
  }, [state, atendimentoId]);

  useEffect(() => {
    if ((statusSalvar == "NOVO" || statusSalvar == "S") && !!appointmentId) {
      getAtendimentoDetailData(appointmentId);
      dispatch({
        type: FETCH_ATENDIMENTO_STATUS_SALVAR,
        statusSalvar: "",
        appointmentId: appointmentId
      });
    }
  }, [statusSalvar, appointmentId]);

  useEffect(() => {
    try {
      setIsLoadingInfo(true);
      getExamData();
      getOccupHealth();
      getCareLines();
      setIsLoadingInfo(false);
    } catch (error) {
      console.log(error)
    }
  }, []);

  useEffect(() => {
    const pId = registroAtendimento?.paciente?.id ??
      agendamento?.idPessoa ??
      pessoa?.idPessoa ??
      pessoa?.id;
    if (pId) {
      service.getProblems(pId)
        .then((response: any) => {
          const data: string = response.data.data;
          if (!isNull(data)) {
            setProblems(data);
          }
        })
        .catch((error) => {
          console.error("Erro ao buscar problemas:", error);
        });

      service.getDeveExibirAlta(pId)
        .then((response: any) => {
          if (response?.data?.success) {
            setExibirAltaProfissional(response.data.data);
          }
        })
        .catch((error) => {
          console.error("DetailsAttendanceRecord - Error in DeveExibirAlta:", error);
        });
    }
  }, [pessoa?.id, pessoa?.idPessoa, agendamento?.idPessoa, registroAtendimento?.paciente?.id]);

  useEffect(() => {
    getOccupHealth();
  }, [selectedOccupHealth]);

  useEffect(() => {
    const savedCompanyStr = localStorage.getItem('currentCompany');

    if (savedCompanyStr) {
      const savedCompany = JSON.parse(savedCompanyStr);
      setUseClinicFrame(savedCompany.usaClinicFrame);
      
      if (savedCompany.usaClinicFrame) {
        ClinicFrameConfiguracaoService.getConfiguracao(savedCompany.id).then((resp: any) => {
            if (resp.data && resp.data.data) {
                setClinicFrameConfig(resp.data.data);
            }
        });
      }
    }

    const savedCurrentProfile = localStorage.getItem('currentProfile');

    if (savedCurrentProfile) {
      setProfile(savedCurrentProfile);
    }

  }, []);

  useEffect(() => {
    const pessoaId =
      registroAtendimento?.paciente?.id ??
      agendamento?.idPessoa ??
      pessoa?.idPessoa ??
      pessoa?.id;
    if (pessoaId) {
      const personService = new PersonService();
      personService
        .getMedicoFamilia(pessoaId)
        .then(({ data: { data } }: any) => {
          setMedicoFamiliaNome(data?.nome ?? undefined);
        })
        .catch(() => {
          setMedicoFamiliaNome(undefined);
        });

      const navService = new NavegacaoService();
      navService.getAtivaPorPaciente(pessoaId)
        .then((res: any) => {
          setIsAlreadyInNavigation(!!res?.data?.data);
        })
        .catch(() => {
          setIsAlreadyInNavigation(false);
        });
    }
  }, [registroAtendimento?.paciente?.id, agendamento?.idPessoa, pessoa?.idPessoa, pessoa?.id]);

  useEffect(() => {
    const exames: Exam[] = [];

    selectedCareLines.forEach((cl: any) => {
      const careLine = careLineList.filter(careLine => careLine.id === cl.id);
      careLine[0].exames.forEach((exame: any) => {
        const examIndex = exames.findIndex((exam: any) => {
          return exam.id === exame.id;
        });
        if (examIndex === -1) {
          const examToInsert: any[] = allExams.filter(ex => ex.id === exame.id);
          exames.push(examToInsert[0]);
        }
      });
    });

    selectedOccupHealth.forEach((ocp: any) => {
      ocp.exames.forEach((exame: any) => {
        const examIndex = exames.findIndex((exam: any) => {
          return exam.id === exame.id;
        });
        if (examIndex === -1) {
          const examToInsert: any[] = allExams.filter(ex => ex.id === exame.id);
          exames.push(examToInsert[0]);
        }
      });
    });

    setExamsToSelected(exames);
  }, [selectedCareLines, selectedOccupHealth]);

  const mountAppointmentObject = () => {
    const cids =
      evolucaoObject.cidSecundario.id !== undefined &&
        evolucaoObject.cidPrincipal.id !== undefined
        ? [evolucaoObject.cidPrincipal.id, evolucaoObject.cidSecundario.id]
        : [];

    const encaminhamentoObject = encaminhamentos
      .map((value: any) => ({
        especialidadeId: value.especialidade?.id || value.especialidade || "",
        resumoAtendimento: value.resumo || "",
        examesComplementares: value.examesComplementares || "",
        hipotesesMotivosReferenciar: value.hipoteses || "",
      }));

    const liberacoesObject = liberacoes
      .filter((l: any) => !l.id)
      .map((value: any) => ({
        categoriaId: value.tipoProfissional?.id || "",
        numeroSessoes: value.numeroSessoes,
        orientacoes: value.orientacoes,
      }));

    const solicitacoesExamesObject = selectedExams.map((value: any) => ({
      exameId: value.id,
      exameAdicional: false,
    }));

    const solicitacoesExamesAdicionaisObject = extraExams.map((value: any) => ({
      exameId: value.exame.id,
      exameAdicional: true,
      justificativa: value.justificativa,
    }));
    const allExamsSolicits = [
      ...solicitacoesExamesObject,
      ...solicitacoesExamesAdicionaisObject,
    ];

    const atestadoObject =
      atestadoDeclaracao.tipo === "atestado"
        ? {
          dia: moment(atestadoDeclaracao.data, "DD/MM/YYYY").format(
            "YYYY-MM-DD"
          ),
          horaInicio: atestadoDeclaracao.horario,
          diasAfastamento: atestadoDeclaracao.diasAfastados,
          notas: atestadoDeclaracao.notas,
        }
        : null;

    const declaracaoObject =
      atestadoDeclaracao.tipo === "declaracao"
        ? {
          dia: moment(atestadoDeclaracao.data, "DD/MM/YYYY").format(
            "YYYY-MM-DD"
          ),
          horaInicio: atestadoDeclaracao.horario,
          horaFim: atestadoDeclaracao.horarioFim,
          notas: atestadoDeclaracao.notas,
        }
        : null;

    const object = {
      profissionalId: userInfo.id,
      pacienteId: pessoa.idPessoa,
      horario: agendamento.horario,
      tipoConsulta: agendamento.tipoConsulta,
      agendamentoId: agendamento.id,
      linhasCuidado: selectedCareLines.map((value: any) => ({
        linhaCuidadoId: value.id,
      })),
      saudesOcupacionais: selectedOccupHealth.map((value: any) => ({
        saudeOcupacionalId: value.id,
      })),
      sinaisVitais: triagemObject.sinaisVitaisList
        .filter((sv: any) => !sv.id || sv.id === "0" || sv.id === "") // Only send new ones if that's the logic? 
        // Actually, send all that are new. Existing ones are ignored by backend anyway if they have an ID.
        // But the requirement says "permitida apenas a inclusão de novos registros".
        .map((sv: any) => ({
          sinalVitalId: sv.sinalVitalId,
          valor: sv.valor,
          valorSecundario: sv.valorSecundario,
          unidade: sv.unidade,
          local: sv.local,
          instrumento: sv.instrumento
        })),
      triagemSinaisVitais: triagemObject.sinaisVitais,
      evolucaoSubjetivo: evolucaoObject.subjetivo,
      evolucaoObjetivo: evolucaoObject.objetivo,
      evolucaoAvaliacao: evolucaoObject.avaliacao,
      cid: cids.filter(cid => cid !== ""),
      evolucaoPlano: evolucaoObject.plano,
      receituarios: receituarios,
      receituarioEspecial: receituariosEspeciais,
      atestado: atestadoObject,
      declaracao: declaracaoObject,
      problemas: problems,
      encaminhamentos: encaminhamentoObject.filter((enc: any) => {
        return (
          enc.especialidadeId !== "" &&
          enc.resumoAtendimento !== "" &&
          enc.examesComplementares !== "" &&
          enc.hipotesesMotivosReferenciar !== ""
        );
      }),
      liberacoesProfissionais: liberacoesObject.filter((lib: any) => {
        return (
          lib.categoriaId !== "" &&
          lib.numeroSessoes !== ""
        );
      }),
      altasProfissionais: altas
        .filter((alta: any) => !alta.id && alta.motivo !== "")
        .map((alta: any) => ({
          dataHora: alta.dataHora,
          motivo: alta.motivo,
        })),
      solicitacoesExames: allExamsSolicits.filter(exam => exam.exameId !== ""),
      consultorio: "consultorio",
      observacoes: "observacoes",
      navegacao: navegacao
        ? {
            risco: navegacao.risco,
            linhasCuidadoId: navegacao.linhasCuidadoId,
            motivo: navegacao.motivo,
            dataAprazamento: navegacao.dataAprazamento,
            turnoAprazamento: navegacao.turnoAprazamento,
          }
        : null,
    };

    return object;
  };

  /*const validateFields = (isSalvar: boolean) => {
    const errors = [];
    const isHorarioInicialInvalido =
      (atestadoDeclaracao.horario !== "" &&
        atestadoDeclaracao.horario.slice(-1) !== "0") ||
      (atestadoDeclaracao.horario !== "" &&
        atestadoDeclaracao.horario.length < 5) ||
      (atestadoDeclaracao.horario !== "" &&
        Number(atestadoDeclaracao.horario.slice(0, 2)) > 23);
    const isHorarioFinalInvalido =
      (atestadoDeclaracao.horarioFim !== "" &&
        atestadoDeclaracao.horarioFim.slice(-1) !== "0") ||
      (atestadoDeclaracao.horarioFim !== "" &&
        atestadoDeclaracao.horarioFim.length < 5) ||
      (atestadoDeclaracao.horarioFim !== "" &&
        Number(atestadoDeclaracao.horarioFim.slice(0, 2)) > 23);
    const isHorarioFinalVazio = atestadoDeclaracao.horarioFim === "";

    if (
      (atestadoDeclaracao.tipo === "atestado" && isHorarioInicialInvalido) ||
      (atestadoDeclaracao.tipo === "declaracao" &&
        (isHorarioInicialInvalido ||
          isHorarioFinalInvalido ||
          (isSalvar ? false : isHorarioFinalVazio)))
    ) {
      errors.push({ message: "Horários inválidos ou vazios" });
    }

    return errors;
  };*/

  const validateFields = (isSalvar: boolean) => {
    const errors = [];

    // Função para validar o formato de hora "hh:mm"
    const isHorarioValido = (hora: string) => {
      const regex = /^([01]\d|2[0-3]):([0-5]\d)$/;
      return regex.test(hora);
    };

    // Função para converter horário "hh:mm" para minutos desde o início do dia
    const parseHora = (hora: string) => {
      if (isHorarioValido(hora)) {
        const [hh, mm] = hora.split(':').map(Number);
        return hh * 60 + mm;
      }
      return NaN;
    };

    // Verifica se o horário inicial é válido
    const isHorarioInicialInvalido = !isHorarioValido(atestadoDeclaracao.horario);

    // Verifica se o horário final é válido
    const isHorarioFinalInvalido = !isHorarioValido(atestadoDeclaracao.horarioFim);

    // Verifica se o horário final está vazio
    const isHorarioFinalVazio = atestadoDeclaracao.horarioFim === "";

    // Converte os horários para minutos
    const horarioInicialMinutos = parseHora(atestadoDeclaracao.horario);
    const horarioFinalMinutos = parseHora(atestadoDeclaracao.horarioFim);

    // Verifica se o intervalo entre horários é válido
    const isIntervaloInvalido = !isNaN(horarioInicialMinutos) &&
      !isNaN(horarioFinalMinutos) &&
      horarioFinalMinutos <= horarioInicialMinutos;

    // Adiciona erros se qualquer validação falhar
    if (
      (atestadoDeclaracao.tipo === "atestado" && isHorarioInicialInvalido) ||
      (atestadoDeclaracao.tipo === "declaracao" &&
        (isHorarioInicialInvalido ||
          isHorarioFinalInvalido ||
          (isSalvar ? false : isHorarioFinalVazio) ||
          isIntervaloInvalido))
    ) {
      errors.push({ message: "Horários inválidos ou vazios" });
    }

    // Validação de Sinais Vitais (Requisito 6.7 e 6.10)
    triagemObject.sinaisVitaisList.forEach((sv: any) => {
      const isNew = !sv.id || sv.id === "0" || sv.id === "";
      if (isNew) {
        if (!sv.sinalVitalId) {
          errors.push({ message: "Selecione o tipo de sinal vital para todos os registros novos" });
        } else {
          if (!sv.valor || sv.valor.trim() === "") {
            const msg = sv.tipoCampo === 'calculado' 
              ? `O valor do sinal vital ${sv.sinalVitalNome} não pôde ser calculado. Verifique se os requisitos (como Peso e Altura) foram preenchidos.`
              : `O campo 'Valor' é obrigatório para o sinal vital ${sv.sinalVitalNome}`;
            errors.push({ message: msg });
          }
          
          // Instrument is NOT mandatory for calculated fields
          if (sv.tipoCampo !== 'calculado' && (!sv.instrumento || sv.instrumento.trim() === "")) {
            errors.push({ message: `O campo 'Instrumento' é obrigatório para o sinal vital ${sv.sinalVitalNome}` });
          }
        }
      }
    });

    if (navegacao) {
      if (!navegacao.risco) {
        errors.push({ message: "O campo 'Risco' é obrigatório no processo de navegação" });
      }
      if (!navegacao.motivo || navegacao.motivo.trim() === "") {
        errors.push({ message: "O campo 'Motivo' é obrigatório no processo de navegação" });
      }
      if (!navegacao.dataAprazamento) {
        errors.push({ message: "O campo 'Data do Aprazamento' é obrigatório no processo de navegação" });
      } else {
        const selectedDate = moment(navegacao.dataAprazamento, 'YYYY-MM-DD');
        const today = moment().startOf('day');
        if (selectedDate.isBefore(today)) {
          errors.push({ message: "A data do aprazamento não pode ser retroativa" });
        }
      }
      if (!navegacao.turnoAprazamento) {
        errors.push({ message: "O campo 'Turno do Aprazamento' é obrigatório no processo de navegação" });
      } else if (navegacao.dataAprazamento) {
        const selectedDate = moment(navegacao.dataAprazamento, 'YYYY-MM-DD');
        const today = moment().startOf('day');
        if (selectedDate.isSame(today, 'day')) {
          const hour = moment().hour();
          if (navegacao.turnoAprazamento === 'Manhã' && hour >= 12) {
            errors.push({ message: "Para a data de hoje, selecione apenas turnos futuros (o turno Manhã já se encerrou)" });
          } else if (navegacao.turnoAprazamento === 'Tarde' && hour >= 18) {
            errors.push({ message: "Para a data de hoje, selecione apenas turnos futuros (o turno Tarde já se encerrou)" });
          } else if (hour >= 18) {
            errors.push({ message: "Para a data de hoje, nenhum turno futuro está disponível" });
          }
        }
      }
    }

    return errors;
  };


  const onSalvarParaImprimir = async (isSalvar: boolean) => {
    try {
      const errors = validateFields(isSalvar);
      if (errors.length === 0) {
        const atendimentoToSave = mountAppointmentObject();

        await dispatch(
          appointmentActions.registerAppointment(
            atendimentoToSave,
            isSalvar,
            atendimentoFinalizadoInfo.atendimentoId
          )
        );
        setShowModalFinalizar(false);
        setModalAttendance(true);
      } else {
        setError(errors);
        setShowModalFinalizar(false);
      }
    } catch (error: any) {
      setShowModalFinalizar(false);
      handleBackendErrors(error, setError);
    }
  };
  const onSalvar = async (isSalvar: boolean) => {
    try {
      setIsEnabled(false);
      const errors = validateFields(isSalvar);
      if (errors.length === 0) {
        const atendimentoToSave = mountAppointmentObject();

        await dispatch(
          appointmentActions.registerAppointment(
            atendimentoToSave,
            isSalvar,
            atendimentoFinalizadoInfo.atendimentoId
          )
        );

        setShowModalFinalizar(false);
      } else {
        setError(errors);
        setShowModalFinalizar(false);
      }
    } catch (error: any) {
      setShowModalFinalizar(false);
      handleBackendErrors(error, setError);

    } finally {
      await new Promise(resolve => setTimeout(resolve, 3000));
      setIsEnabled(true);
    }
  };

  const onSalvarOuFinalizar = async (isSalvar: boolean, justification?: string) => {
    try {
      const errors = validateFields(isSalvar);
      if (errors.length === 0) {
        const atendimentoToSave = mountAppointmentObject();

        const payload = {
          ...atendimentoToSave,
          usuarioFinalizacaoId: userInfo.id,
          justificativaFinalizacao: justification || "",
        };

        setIsFinalizing(true);
        await dispatch(
          appointmentActions.registerAppointment(
            payload,
            isSalvar,
            atendimentoFinalizadoInfo.atendimentoId
          )
        );
        setShowModalFinalizar(false);
        setShowJustificationModal(false);
        navigate(Paths.Prontuario, {
          state: { pessoa: pessoa, agendamento: agendamento },
        });
      } else {
        setError(errors);
        setShowModalFinalizar(false);
      }
    } catch (error: any) {
      setShowModalFinalizar(false);
      setShowJustificationModal(false);
      handleBackendErrors(error, setError);
    } finally {
      setIsFinalizing(false);
    }

    window.scrollTo({ top: 0, left: 0 });
  };

  const handleFinalizarClick = () => {
    // Verifica se o profissional que está finalizando é diferente do responsável já gravado no atendimento
    const isDifferentProfessional =
      !!registroAtendimento?.profissional?.id &&
      userInfo.id !== registroAtendimento.profissional.id;

    if (isDifferentProfessional) {
      setShowJustificationModal(true);
    } else {
      setShowModalFinalizar(true);
    }
  };

  return (
    <>
      <ContainerWithSidebar>
        <GeneralContainer>
          <TextLink
            color={Colors.SPM600}
            onClick={() => {
              navigate(-1);
            }}
          >
            {"< Voltar para prontuário"}
          </TextLink>
          <Spacer top={20} />
          <H1>Registro de Atendimentos</H1>
          <Spacer top={10} />
          <ErrorArea
            errorList={error}
            onCloseAction={() => {
              setError([]);
            }}
          />
          <Spacer top={35} />
          <Contents>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', margin: 3 }}>
              <H2 style={{ margin: 0 }}>{registroAtendimento ? registroAtendimento?.paciente?.nome : agendamento.nome}</H2>
              {isAlreadyInNavigation && (
                <span style={{
                  backgroundColor: '#d32f2f',
                  color: '#fff',
                  padding: '4px 10px',
                  borderRadius: 20,
                  fontSize: '0.75rem',
                  fontWeight: 600,
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px'
                }}>
                  Em Navegação
                </span>
              )}
            </div>
            <div style={{ flexDirection: "row", display: "flex", gap: 5 }}>
              <H3 style={{ margin: 3 }}>Data de Nascimento:</H3>
              <H3 style={{ fontWeight: "lighter", margin: 3 }}>
                {registroAtendimento ? moment(registroAtendimento?.paciente?.dataNascimento).format("LL") : moment(agendamento.dataNascimento).format("LL")} { }
              </H3>
            </div>
            <div style={{ flexDirection: "row", display: "flex", gap: 5 }}>
              <H3 style={{ margin: 3 }}>Médico de família:</H3>
              <H3 style={{ fontWeight: "lighter", margin: 3 }}>
                {medicoFamiliaNome ?? "Não possui"}
              </H3>
            </div>

            <Spacer top={10} />
            {isViewState && (
              <BoxAtendimentoFinalizado>
                <H2>Atendimento finalizado</H2>
                <div style={{ flexDirection: "row", display: "flex", gap: 5 }}>
                  <H3>Profissional responsável:</H3>
                  <H3 style={{ fontWeight: "lighter" }}>
                    {atendimentoFinalizadoInfo.profissional}
                  </H3>
                </div>
                <div style={{ flexDirection: "row", display: "flex", gap: 5 }}>
                  <H3>Tipo de profissional:</H3>
                  <H3 style={{ fontWeight: "lighter" }}>
                    {atendimentoFinalizadoInfo.tipoDeProfissional}
                  </H3>
                </div>
                <div style={{ flexDirection: "row", display: "flex", gap: 5 }}>
                  <H3>Data:</H3>
                  <H3 style={{ fontWeight: "lighter" }}>
                    {atendimentoFinalizadoInfo.data}
                  </H3>
                </div>
                {atendimentoFinalizadoInfo.justificativa && (
                 <>
                   <div style={{ flexDirection: "row", display: "flex", gap: 5 }}>
                     <H3>Finalizado por:</H3>
                     <H3 style={{ fontWeight: "lighter" }}>
                       {atendimentoFinalizadoInfo.finalizadoPor}
                     </H3>
                   </div>
                   <div style={{ flexDirection: "row", display: "flex", gap: 5 }}>
                     <H3>Em:</H3>
                     <H3 style={{ fontWeight: "lighter" }}>
                       {atendimentoFinalizadoInfo.finalizadoEm}
                     </H3>
                   </div>
                   <div style={{ flexDirection: "row", display: "flex", gap: 5 }}>
                     <H3>Justificativa:</H3>
                     <H3 style={{ fontWeight: "lighter" }}>
                       {atendimentoFinalizadoInfo.justificativa}
                     </H3>
                   </div>
                 </>
                )}
              </BoxAtendimentoFinalizado>
            )}

            <Spacer top={10} />
            <BoxAttendance>
              <H2 bold color={Colors.SPM800}>
                Atendimentos
              </H2>
              <Subtitle>
                Selecione quais opções foram atendidas nesse atendimento.
              </Subtitle>
              <Spacer top={30} />

              <H3>Linhas de Cuidado</H3>
              <Box style={{ flexDirection: "column", display: "flex" }}>
                {isLoadingInfo ? (
                  <div>
                    <CircularProgress />
                  </div>
                ) : (
                  <>
                    {personCareLines.map((cl: any, index: number) => {
                      return (
                        <div
                          key={cl.id || index}
                          style={{
                            flexDirection: "row",
                            display: "flex",
                            gap: 10,
                            width: "100%",
                            marginBottom: -15,
                          }}
                        >
                          <CheckBox
                            type="checkbox"
                            disabled={isViewState}
                            checked={
                              selectedCareLines.findIndex((linhaCuidado: any) => {
                                return linhaCuidado.id === cl.id;
                              }) !== -1
                            }
                            style={{ marginTop: 15 }}
                            onChange={() => {
                              setSelectedCareLines((prev: any) => {
                                const list = [...prev];
                                const currentIndex = list.findIndex(
                                  (linhaCuidado: any) => {
                                    return linhaCuidado.id === cl.id;
                                  }
                                );

                                currentIndex === -1
                                  ? list.push(cl)
                                  : list.splice(currentIndex, 1);
                                return list;
                              });
                            }}
                          />
                          <OptionSelect>{cl.nome}</OptionSelect>
                        </div>
                      );
                    })}
                  </>
                )}
              </Box>
              {/*  MOSTRAR APENAS QUANDO NÃO É DEPENDENTE*/}
              {
                !dependenteProfile && (
                  <>
                    <H3>Saúde ocupacional</H3>
                    <Box style={{ flexDirection: "column", display: "flex" }}>
                      {isLoadingInfo ? (
                        <div>
                          <CircularProgress />
                        </div>
                      ) : (
                        <>
                          {personOccupHealth.map((ocp: any, index: number) => {
                            return (
                              <div
                                key={ocp.id || index}
                                style={{
                                  flexDirection: "row",
                                  display: "flex",
                                  gap: 10,
                                  width: "100%",
                                  marginBottom: -15,
                                }}
                              >
                                <CheckBox
                                  type="checkbox"
                                  name="tabagismo"
                                  disabled={isViewState}
                                  checked={
                                    selectedOccupHealth.findIndex(
                                      (occupHealth: any) => {
                                        return occupHealth.id === ocp.id;
                                      }
                                    ) !== -1
                                  }
                                  style={{ marginTop: 15 }}
                                  onChange={() => {
                                    setSelectedOccupHealth((prev: any) => {
                                      const list = [...prev];
                                      const currentIndex = list.findIndex(
                                        (linhaCuidado: any) => {
                                          return linhaCuidado.id === ocp.id;
                                        }
                                      );

                                      currentIndex === -1
                                        ? list.push(ocp)
                                        : list.splice(currentIndex, 1);
                                      return list;
                                    });
                                  }}
                                />
                                <OptionSelect>{`${ocp.nome} - ${ocp.nomeEmpresa}`}</OptionSelect>
                              </div>
                            );
                          })}
                        </>
                      )}
                    </Box>
                  </>
                )
              }
            </BoxAttendance>

            <DetailsAttendanceRecordAccordion
              name={"Triagem"}
              isCollapsable={false}
            >
              <TriagemField
                isViewState={isViewState}
                triagem={triagemObject}
                setTriagemObject={setTriagemObject}
                pessoa={pessoa}
                onSalvar={() => onSalvar(true)}
                acessoProntuario={acessoProntuario}
                isLoading={!isEnabled}
              />
            </DetailsAttendanceRecordAccordion>

            <DetailsAttendanceRecordAccordion
              name={"Lista de Problemas"}
              isCollapsable={false}
            >
              <ListaDeProblemasField
                isViewState={isViewState}
                listaDeProblemas={problems}
                setListaDeProblemas={setProblems}
              />
            </DetailsAttendanceRecordAccordion>

            <DetailsAttendanceRecordAccordion
              name={"Evolução"}
              isCollapsable={false}
            >
              <EvolucaoField
                isViewState={isViewState}
                evolucao={evolucaoObject}
                setEvolucaoObject={setEvolucaoObject}
              />
            </DetailsAttendanceRecordAccordion>


            <DetailsAttendanceRecordAccordion
              name={"Receituário"}
              isCollapsable={false}
            >

              {(useClinicFrame && registroAtendimento?.clinicFrameId !== null && clinicFrameConfig) &&
                <div>
                  <OutlinedUpdateButton
                    aria-disabled={true}
                    isMobile={false}
                    style={{ height: 20, width: 250, marginTop: 20 }}
                    onClick={() => {
                      if (registroAtendimento === undefined) {
                        onSalvar(true);
                      } else {
                        const url = clinicFrameConfig.url;
                        let params = "";
                        if (registroAtendimento?.finalizado || profile != 'MED')
                          params = clinicFrameConfig.urlParamsReceituario || "p=H";
                        else
                          params = clinicFrameConfig.urlParamsAtendimento || "p=M,H,E,D";
                        
                        window.open(`${url}${url.includes('?') ? '&' : '?'}${params}&a=${registroAtendimento?.clinicFrameId}`, '_blank');
                      }
                    }}
                  >
                    <BiLinkExternal />
                    Receituário Eletrônico
                  </OutlinedUpdateButton>
                </div>
              }

              <ReceituarioField
                isViewState={isViewState}
                receituarios={receituarios}
                receituariosEspeciais={receituariosEspeciais}
                setReceituarios={setReceituarios}
                setReceituariosEspeciais={setReceituariosEspeciais}
                useClinicFrame={useClinicFrame}
                profile={profile}
              />
            </DetailsAttendanceRecordAccordion>



            <DetailsAttendanceRecordAccordion
              name={"Solicitação de exames"}
              isCollapsable={false}
            >
              <ExamesField
                isViewState={isViewState}
                exames={examesToSelect}
                selectedExames={selectedExams}
                setSelectedExames={setSelectedExams}
                extraExams={extraExams}
                setExtraExams={setExtraExams}
              />
            </DetailsAttendanceRecordAccordion>

            <DetailsAttendanceRecordAccordion
              name={"Atestado/Declaração"}
              isCollapsable={true}
            >
              <AtestadoDeclaracaoField
                isViewState={isViewState}
                atestadoDeclaracao={atestadoDeclaracao}
                setAtestadoDeclaracao={setAtestadoDeclaracao}
              />
            </DetailsAttendanceRecordAccordion>

            <DetailsAttendanceRecordAccordion
              name={"Encaminhamento para especialista"}
              isCollapsable={true}
            >
              <EncaminhamentoField
                isViewState={isViewState}
                encaminhamentos={encaminhamentos}
                setEncaminhamentos={setEncaminhamentos}
              />
            </DetailsAttendanceRecordAccordion>

            {(currentProfile === "MED" || currentProfile === "ENF" || profile === "MED" || profile === "ENF") && (
              <DetailsAttendanceRecordAccordion
                name={"Liberação para profissional"}
                isCollapsable={true}
              >
                <LiberacaoField
                  isViewState={isViewState}
                  liberacoes={liberacoes}
                  setLiberacoes={setLiberacoes}
                />
              </DetailsAttendanceRecordAccordion>
            )}
            {((!isViewState && exibirAltaProfissional) || altas.some((a: any) => a.id && a.id !== "0")) && (
              <DetailsAttendanceRecordAccordion
                name={"Alta profissional"}
                isCollapsable={true}
              >
                <AltaProfissionalField
                  isViewState={isViewState}
                  altas={altas}
                  setAltas={setAltas}
                />
              </DetailsAttendanceRecordAccordion>
            )}
            {(!isViewState ? !isAlreadyInNavigation : !!navegacao) && (
              <DetailsAttendanceRecordAccordion
                name={"Navegação"}
                isCollapsable={true}
              >
                <NavegacaoField
                  isViewState={isViewState}
                  navegacao={navegacao}
                  setNavegacao={setNavegacao}
                  selectedCareLines={selectedCareLines}
                />
              </DetailsAttendanceRecordAccordion>
            )}
          </Contents>

          <Spacer top={80} />

          {!isViewState && (
            <div
              style={{
                flexDirection: isMobile ? "column" : "row",
                display: "flex",
                justifyContent: "space-between",
                width: "90%",
                paddingLeft: 10,
              }}
            >
              <div
                style={{
                  flexDirection: isMobile ? "column" : "row",
                  display: "flex",
                  gap: 12,
                  width: "100%",
                }}
              >
                {
                  !acessoProntuario ?
                    <CancelButton
                      onClick={() => {
                        navigate(-1);
                      }}
                      isMobile={isMobile}
                    >
                      Cancelar
                    </CancelButton>
                    :
                    ''
                }
                {
                  !acessoProntuario ?
                    <GenericSolidButton
                      color={Colors.SPM600}
                      width={25}
                      onClick={() => {
                        onSalvarParaImprimir(true);
                      }}
                    >
                      Imprimir
                    </GenericSolidButton>
                    :
                    ''
                }
                {
                  !acessoProntuario ?
                    <GenericSolidButton
                      color={Colors.SPM600}
                      width={25}
                      ref={ref}
                      disabled={!isEnabled}
                      onClick={() => {
                        onSalvar(true);
                      }}
                    >
                      {!isEnabled ? (
                        <div style={{ display: "flex", alignItems: "center", gap: 8, justifyContent: "center" }}>
                          <CircularProgress size={16} sx={{ color: "white" }} />
                          <span>Salvando...</span>
                        </div>
                      ) : (
                        "Salvar"
                      )}
                    </GenericSolidButton>
                    :
                    ''
                }
              </div>
              {
                !acessoProntuario ?
                  <GenericSolidButton
                    width={25}
                    onClick={handleFinalizarClick}
                    color={Colors.SPM600}
                    style={{
                      marginTop: isMobile ? 10 : 0,
                      marginBottom: isMobile ? 40 : 0,
                    }}
                  >
                    Finalizar
                  </GenericSolidButton>
                  :
                  ''
              }

            </div>
          )}

          {isViewState && (
            <div
              style={{
                flexDirection: isMobile ? "column" : "row",
                display: "flex",
              }}
            >
              <CancelButton
                onClick={() => {
                  navigate(-1);
                }}
                isMobile={isMobile}
              >
                Voltar
              </CancelButton>
              <GenericSolidButton
                style={{
                  marginLeft: "20px",
                }}
                color={Colors.SPM600}
                width={25}
                onClick={() => {
                  setModalAttendance(true);
                }}
              >
                Imprimir
              </GenericSolidButton>
            </div>
          )}
        </GeneralContainer>
        <GenericModal
          visible={showModalFinalizar}
          onCancel={() => {
            onSalvarOuFinalizar(false);
          }}
          onConfirm={() => {
            setShowModalFinalizar(false);
          }}
          modalTitle={"Tem certeza que deseja finalizar esse atendimento?"}
          modalSubtitle={
            "Esse atendimento será finalizado e não será mais possível fazer alterações no registro"
          }
          cancelButtonMsg={"Voltar"}
          confirmButtonMsg={"Finalizar"}
          isLoading={isFinalizing}
        />
        <JustificationFinalizationModal
          visible={showJustificationModal}
          onCancel={() => setShowJustificationModal(false)}
          onConfirm={(justification) => onSalvarOuFinalizar(false, justification)}
          isLoading={isFinalizing}
        />
        <ModalImpreviveis
          idAtendimento={atendimentoFinalizadoInfo.atendimentoId}
          modalOpen={modalAttendance}
          dados={{
            receituarios: receituarios.length > 0 && receituarios[0].descricao.length > 0 ? false : true,
            receituariosEspeciais:
              receituariosEspeciais.length > 0 && receituariosEspeciais[0].descricao.length > 0 ? false : true,
            exames: (selectedExams.length + extraExams.length) > 0 ? false : true,
            atestadoDeclaracao: atestadoDeclaracao.tipo.length > 0 ? false : true,
            encaminhamentos:
              encaminhamentos.length > 0 && (typeof encaminhamentos[0].especialidade !== "string") ? false : true,
            liberacaoProfissional:
              liberacoes.length > 0 && (typeof liberacoes[0].tipoProfissional !== "string") ? false : true,
            evolucao:
              evolucaoObject.avaliacao.length > 0 ||
                evolucaoObject.cidPrincipal?.descricao.length > 0 ||
                evolucaoObject.objetivo.length > 0 ||
                evolucaoObject.plano.length > 0 ||
                evolucaoObject.subjetivo.length > 0
                ? false
                : true,
          }}
          onCloseModal={() => setModalAttendance(false)}
        />
      </ContainerWithSidebar>
      {!isViewState &&
        <ProntuarioDrawer pacienteId={registroAtendimento?.paciente?.id ?? pessoa.idPessoa} />
      }
    </>
  );
}
export default DetailsAttendanceRecord;
